const MAP = {
  draft: { label: "DRAFT", color: "#71717A", dot: false },
  running: { label: "LIVE", color: "#16A34A", dot: true },
  paused: { label: "PAUSED", color: "#B45309", dot: false },
  stopped: { label: "STOPPED", color: "#DC2626", dot: false },
  completed: { label: "DONE", color: "#16A34A", dot: false },
  sent: { label: "SENT", color: "#16A34A", dot: false },
  failed: { label: "FAILED", color: "#DC2626", dot: false },
  pending: { label: "PENDING", color: "#71717A", dot: false },
  sending: { label: "SENDING", color: "#B45309", dot: true },
  scheduled: { label: "SCHEDULED", color: "#2563EB", dot: true },
  queued: { label: "QUEUED", color: "#B45309", dot: false },
  delivered: { label: "DELIVERED", color: "#16A34A", dot: false },
  bounced: { label: "BOUNCED", color: "#DC2626", dot: false },
  undelivered: { label: "UNDELIVERED", color: "#DC2626", dot: false },
  replied: { label: "REPLIED", color: "#0D9488", dot: true },
  opt_out: { label: "OPT-OUT", color: "#DC2626", dot: false },
};

export function StatusBadge({ status }) {
  const s = MAP[status] || MAP.draft;
  return (
    <span
      data-testid={`status-${status}`}
      className="inline-flex items-center gap-1.5 px-2 py-1 border font-mono text-[11px] uppercase tracking-wider whitespace-nowrap"
      style={{ color: s.color, borderColor: s.color + "55", background: s.color + "12" }}
    >
      {s.dot && <span className="w-1.5 h-1.5 rounded-full sv-pulse" style={{ background: s.color }} />}
      {s.label}
    </span>
  );
}
